export default __webpack_public_path__ + "static/page-bg-fd492e27ef9314d9a244e7753d5acb86.jpg";